import {useAccess} from '@umijs/max';
import type {ButtonProps, TooltipProps} from 'antd';
import {Button, Tooltip} from 'antd';
import React from 'react';

interface AuthButtonProps extends ButtonProps {
  code: string;
  children?: React.ReactNode;
  /** 按钮提示文字，传入后按钮会带有 Tooltip */
  tooltip?: React.ReactNode;
  /** Tooltip 其他配置，仅在传了 tooltip 时生效 */
  tooltipProps?: Omit<TooltipProps, 'title'>;
}

/**
 * 带权限控制的按钮组件
 * @param code 权限码，如 'system:user:add'
 * @param tooltip 提示文字，传入后自动包裹 Tooltip
 */
const AuthButton: React.FC<AuthButtonProps> = ({code, children, tooltip, tooltipProps, ...rest}) => {
  const access = useAccess();
  // 超级管理员拥有所有权限
  const hasPermission = access.isSuperAdmin || (access as any)[code] || access.canAccess?.(code);

  if (!hasPermission) return null;

  const btn = <Button {...rest}>{children}</Button>;

  if (tooltip) {
    return (
      <Tooltip title={tooltip} {...tooltipProps}>
        {btn}
      </Tooltip>
    );
  }

  return btn;
};

export default AuthButton;
